import type { NotificationsState } from './notification-selectors';

import type { Action } from './utils/state-manager';

const InitialState: NotificationsState = [];

const notificationDefaults = {
  open: true,
};

export default (state = InitialState, action: Action) => {
  switch (action.type) {
    case 'ADD_NOTIFICATION': {
      const notifications = state.slice();
      const index = notifications.findIndex((n) => n.key === action.payload.key);
      if (index > -1) {
        notifications.splice(index, 1);
      }
      notifications.push({ ...notificationDefaults, ...action.payload });
      return notifications;
    }
    case 'CLOSE_NOTIFICATION': {
      const notifications = state.slice();
      /*
      Rather than removing the item from the array, we
      mark it as no longer open so it doesn't just abruptly disappear.
      Instead it transitions out appropriately.
       */
      const index = notifications.findIndex((n) => n.key === action.payload);
      if (index > -1) {
        notifications[index].open = false;
      }
      return notifications;
    }
    default:
      return state;
  }
};
